import { Injectable } from '@angular/core';
import { MantenerMenu } from '../models/mantenerMenu';
import { moduloSeguridad } from '../diccionarios/seguridadModulo.js';
import { Observable } from 'rxjs';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CommonService } from 'src/app/shared/utils/common.service';

@Injectable({
  providedIn: 'root'
})
export class AdminMenuService {

  mdSeguridad: any;
  url: string;
  urlMenu: string;

  constructor(
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.mdSeguridad = moduloSeguridad;
    this.url = this._util.getSeguridad(this.mdSeguridad.url.seguridad.menu);
    this.urlMenu = this._util.getSeguridad(this.mdSeguridad.url.seguridad.admin_menu);
  }

  getAllNivel(innParamNievel: any, inParamenuSuperior: any) {
    return this._commom.peticionGetConHeader(this.urlMenu + innParamNievel + '/' + inParamenuSuperior);
  }

  guardarMenu(objetoMenu: MantenerMenu) {
    return this._commom.peticionPostConHeader(this.url, objetoMenu);
  }

  actualizarMenu(objetoMenu: MantenerMenu) {
    return this._commom.peticionPutConHeader(this.url, objetoMenu);
  }

  eliminarId(inId: any) {
    return this._commom.peticionDeleteConHeader(this.url + '/' + inId);
  }

  getMenu() {
    return this._commom.peticionGetConHeader(this.url + '/nw/' + localStorage.getItem('userName'));
  }

  devolverObservableOk(innParametro: any) {
    return new Observable((observer) => {
      return observer.next(innParametro);
    });
  }
}
